import React from 'react';

import { TableOptionsIcon } from '../Icons';

interface FiltersDropdownProps {
    title: string;
    additionalClasses?: string;
    selectionItems: Record<string, any>[];
    onSelectItem?: (item: string) => void;
    disabled?: boolean;
}

const FiltersDropdown: React.FC<FiltersDropdownProps> = (props) => {
    const { title, additionalClasses, selectionItems, onSelectItem, disabled } = props;

    const ref = React.useRef<HTMLDivElement>(null);

    const [isDropdownActive, setIsDropdownActive] = React.useState<boolean>(false);

    const onTriggerHandler = () => {
        setIsDropdownActive(!isDropdownActive);
    };

    const onSelectItemHandler = (item: string) => {
        onSelectItem(item);
        setIsDropdownActive(true);
    };

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setIsDropdownActive(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [ref]);

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setIsDropdownActive(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [ref]);

    return (
        <div className={`dropdown ${isDropdownActive ? 'is-active' : ''} ${additionalClasses}`} ref={ref}>
            <div tabIndex={0} aria-haspopup="true" className="dropdown-trigger">
                <button className="button is-light" disabled={disabled} onClick={onTriggerHandler}>
                    <span className="icon">
                        <TableOptionsIcon />
                    </span>
                    <span>{title}</span>
                </button>
            </div>

            <div className="dropdown-menu">
                <div role="menu" aria-modal="true" className="dropdown-content">
                    <div className="head">Afficher :</div>
                    {selectionItems?.map((item: Record<string, any>) => {
                        return (
                            <div key={item.key} tabIndex={0} className="dropdown-item">
                                <label className="checkbox is-flex is-align-content-center">
                                    <input
                                        className="mr-2"
                                        type="checkbox"
                                        checked={item.isSelected}
                                        onChange={() => onSelectItemHandler(item.key)}
                                    />

                                    <span className="control-label">{item.title}</span>
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default FiltersDropdown;
